import React, { useState } from 'react';
import CommonTable from './commonTable';
import moment from 'moment';
import { GAME_LANGUAGES } from '../../utils/constants';

const ExamModuleList = ({ data, page, setPage, onFilter, onEdit, onDelete }) => {
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const columns = [
    { header: 'ID', accessor: '_id' },
    { header: 'Status', accessor: 'status' },
    {
      header: 'Language',
      render: (row) => (
        <span>
          {row.language
            ? row.language.charAt(0).toUpperCase() + row.language.slice(1).toLowerCase()
            : '-'}
        </span>
      )
    },
    { header: 'Title', accessor: 'title' },
    { header: 'Date', render: (row) => (row.date ? moment(row.date).format('DD-MM-YYYY') : '-') },
    { header: 'Exam Key', accessor: 'examKey' },
    { header: 'Duration', accessor: 'duration' },
    { header: 'Rechange Answer', render: (row) => (row.canRechangeAnswer ? 'Yes' : 'No') },
    { header: 'Total Question', accessor: 'totalQuestions' },
    {
      header: 'Operate',
      render: (row) => (
        <div className="flex gap-2">
          <button
            className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded"
            onClick={() => onEdit(row)}
            title="Edit"
          >
            <i className="fas fa-edit"></i>
          </button>
          <button
            className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
            title="Delete"
            onClick={() => onDelete(row._id)} // Assuming onDelete is defined to handle deletion
          >
            <i className="fas fa-trash-alt"></i>
          </button>
        </div>
      )
    }
  ];
  const handlePagination = (page) => {
    console.log('Page changed to:', page);
    setPage(page);
    // Implement pagination logic here if needed
  };
  // const handleSearch = (searchTerm) => {
  //   onFilter({ search: searchTerm });
  // };
  return (
    <div>
      <div className="bg-white rounded-lg shadow p-6 m-4">
        {/* Header */}
        <div className="mb-2">
          <span className="text-2xl font-bold text-black-600">Exam Module</span>
        </div>
        <hr className="mb-6" />
        <div className="flex flex-wrap items-center gap-6">
          <select
            value={selectedLanguage}
            onChange={(e) => setSelectedLanguage(e.target.value)}
            className="input-company w-full sm:w-1/3"
          >
            <option value="">Select Language</option>
            {GAME_LANGUAGES.map((lang) => (
              <option key={lang.value} value={lang.value}>
                {lang.name}
              </option>
            ))}
          </select>
          <button
            onClick={() => {
              if (selectedLanguage === '') {
                onFilter({}); // reset filters
              } else {
                onFilter({ language: selectedLanguage });
              }
            }}
            className="btn-primary w-full sm:w-auto block"
          >
            {' '}
            Filter Data
          </button>
        </div>

        {/* Search and actions */}
        <div className="flex justify-end items-center gap-2 mt-4 mb-6">
          <input
            type="text"
            placeholder="Search"
            className="input-company w-full sm:w-1/3"
            onChange={(e) => {
              const timeoutId = setTimeout(() => {
                onFilter({ search: e.target.value });
              }, 500); // 500ms delay

              return () => clearTimeout(timeoutId);
            }}
          />
          <div className="flex gap-1">
            <button className="btn-primary">
              {/* Refresh Icon */}
              <i className="fas fa-sync"></i>
            </button>
            {/* <button className="btn-primary">
              
              <i className="fas fa-th-list"></i>
            </button>
            <button className="btn-primary">
            
              <i className="fas fa-download"></i>
            </button> */}
          </div>
        </div>

        <CommonTable
          columns={columns}
          data={data}
          pagination={true}
          currentPage={page} // Assuming you want to start from page 1
          totalItems={data?.meta?.pagination?.totalItems}
          onPageChange={handlePagination}
        />
      </div>
    </div>
  );
};

export default ExamModuleList;
